<template>
  <div class="MainSearch">
    <!-- 导航栏 -->
    <div class="shortcut">
      <div class="w">
        <div class="fl">
          <ul>
            <li class="home">
              <a href="">
                <img src="../assets/images/brnav_home.png" alt="">
                首页&nbsp;>
              </a>
            </li>
            <li><a href="#">搜索&nbsp;</a></li>
          </ul>
        </div>
      </div>

    </div>
    <!-- 大主体 -->
    <div class="bg_bd">
      <div class="w">
        <div class="main">
          <div class="main_top">
            <div class="serch_left">搜索结果</div>
            <div class="serch_m">
              <input type="search" v-model="inputTwo" name="" id="1" placeholder="请输入搜索关键字" clearable>
              <div class="serch_right">
                <a href="javascript:void(0);" @click="SearchTwo"> <i class="el-icon-search"></i></a>
              </div>
            </div>

          </div>
          <h4 class="main_date">
            关键词“{{this.QuerySearch}}”搜索的结果：<br> 共有{{this.total}}条记录
          </h4>
          <div class="main_z" v-loading="loading">
            <ul v-for="(items,index) in NewsList" :key="index">
              <li class="li_tp">
                <a v-if="items.IsWeixin" :href="items.URL" target="_blank">{{items.Title}}</a>
                <a v-else href="javascript:void(0);" @click="goDetail(items)">{{items.Title}}</a>
              </li>
              <li class="li_md">{{items.Summary}}</li>
              <li class="li_bd">
                <span v-if="items.ReleaseDate">{{items.ReleaseTime}}</span> <span v-else>{{items.DateTime}}</span>   |  {{items.URL}}
              </li>
            </ul>
          </div>
          <div class="pag-box">
            <div class="block">
              <span @click="jumpFirstPage" class="my-btnF">首页</span>
              <el-pagination
                background
                ref="pagination"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="currentPage"
                :page-size="this.pageSize"
                layout="total, prev, pager, next"
                prev-text="上一页"
                next-text="下一页"
                :total="this.total">
              </el-pagination>
              <span @click="jumpLastPage" class="my-btnM">末页</span>
            </div>
            <!--移动端-->
            <div class="addMore">加载更多</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import * as api from '../api/api.js'
  import * as utils from '../utils.js'
  export default {
    name: "search",
    data(){
      return{
        total:0,
        pageSize:10,
        currentPage:1,
        NewsList:[],
        loading:false,
        QuerySearch:this.$route.query.value,
        inputTwo:'',
        Text:'',
        MenusList:[],
        fkey:'',
        key:''
      }
    },
    watch: {
      '$route': function (val) {
        this.init()
        this.getPath()
      }
    },
    created(){
      this.getAllNews()
      this.init()
    },
    methods:{
      init: function (){
        var storage = utils.storage.get('jinLin_menu')
        if (storage && storage.data) {
          this.MenusList = storage.data
        }
      },
      SearchTwo(){
        this.QuerySearch = this.inputTwo
        this.getAllNews()
      },
      getPath(){
        this.QuerySearch = this.$route.query.value
        this.Text = this.$route.query.value
        this.getAllNews()
      },
      getAllNews(){
        var Params ={
          keyword:this.QuerySearch,
          Page: this.currentPage,
          PageSize: this.pageSize
        }
        this.loading = true
        api.allNewsInfo(Params).then(res =>{
          this.loading = false
          if(res.Status === 100){
            res.Data.DataList.find((vv)=>{
              if (vv.IsWeixin) {
                vv.URL = JSON.parse(vv.HtmlContent).url
              }
              vv.DateTime = this.$moment(vv.UpdateDt).format('LL')
              if(vv.ReleaseDate !== null || vv.ReleaseDate !== undefined || vv.ReleaseDate !==''){
                vv.ReleaseTime = this.$moment(vv.ReleaseDate).format('LL')
              }
            })
            this.NewsList = res.Data.DataList
            this.total = res.Data.TotalCount
          }
        })
      },
      goDetail: function (items) {
        this.MenusList.forEach((vv)=>{
          vv.subMenu.forEach((dd)=>{
            if(dd.Id === items.igId){
              this.fkey = vv.Key
              this.key = dd.Key
            }
          })
        })
        const { href } = this.$router.resolve({name: 'newsDetail', params: {fkey: this.fkey, key: this.key, newsId: items.Id}});
        window.open(href, '_blank');
      },
      // 首页
      jumpFirstPage(){
        this.$refs.pagination.handleCurrentChange(1);
        this.$emit('handleCurrentChange', 1);
      },
      // 末页
      jumpLastPage(){
        let font = this.$refs.pagination
        let cpage = Math.ceil(font.total / font.pageSize);
        font.handleCurrentChange(cpage);
      },
      // 分页
      handleSizeChange(val){
        this.pageSize = val
        this.getAllNews()
      },
      handleCurrentChange(val){
        this.currentPage = val
        this.getAllNews()
      }
    }
  }
</script>

<style scoped>
  @import "../assets/search.css";
  .block{
    float: right;
  }
</style>



// WEBPACK FOOTER //
// src/components/search.vue